<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold d-flex padding-sm align-items-center text-sm justify-content-between catalogo-text"
          >
            Registrar Empaque
            <router-link :to="{ name: 'Empaques' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value.sync="$v.nombreEmpaque.$model"
                  :isValid="checkIfValid('nombreEmpaque')"
                  label="Nombre:"
                  placeholder="Nombre..."
                  invalidFeedback="Campo requerido, debe tener al menos 2 caracteres y maximo 100 caracteres"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CSelect
                  :value.sync="$v.nombreCultivo.$model"
                  :isValid="checkIfValid('nombreCultivo')"
                  label="Cultivo:"
                  placeholder="Cultivo..."
                  invalidFeedback="Campo requerido, debe seleccionar una opción"
                  :options="cultivos"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value.sync="$v.costo.$model"
                  :isValid="checkIfValid('costo')"
                  label="Costo"
                  placeholder="Costo.."
                  type="number"
                  prepend="$"
                  invalidFeedback="Campo requerido"
                  @click="()=>costo=costo==0?'':costo"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CAlert
                  fade
                  color="success"
                  class="my-1"
                  :show.sync="currentAlertCounter"
                >Guardado con éxito.</CAlert>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Empaques' }">
              <CButton class="px-4 mx-3 btn-lg" color="danger">Cancelar</CButton>
            </router-link>

            <CButton @click="addEmpaque()" class="px-4 mx-3 btn-lg" color="success">
              <div v-if="isLoading">
                <div class="w-100 d-flex justify-content-center align-items-center">
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
              <span v-else>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>

      <CModal
        size="sm"
        title="Empaque"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
      >{{ error }}</CModal>
    </CRow>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import "vue-select/dist/vue-select.css";

export default {
  name: "NuevoEmpaque",

  components: {
  },

  computed: {
    isValidEmpaque() {
      return !this.$v.nombreEmpaque.$invalid;
    },
    isValidCultivo() {
      return !this.$v.nombreCultivo.$invalid ;
    },
    isValidCosto() {
      return !this.$v.costo.$invalid ;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
    cultivos() {
      return this.configuracion.map(cultivo => {
        return cultivo.nombre
      })
    }
  },

  watch: {
    nombreCultivo: function() {
      this.nombre = ''
      this.embalajeKey += 1
    },
  },

  methods: {
    inputFile(e) {
      let reader = new FileReader();
      this.url = "";
      this.urlName = "";

      reader.onload = file => {
        this.url = file.target.result;
        this.urlName = e.target.files[0].name;
      };

      reader.readAsDataURL(e.target.files[0]);
      //  this.$emit('input', this.value);
    },
    addEmpaque() {
      this.validateEmpaque();

      if (
        this.isValidEmpaque &&
        this.isValidCultivo &&
        this.isValidCosto
      ) {
        this.isLoading = true;

       
          this.$store
            .dispatch("customActualizarHTTP", {
              schema: "empaques",
              payload: {
                nombre: this.nombreEmpaque,
                cultivo: this.nombreCultivo,
                costo: this.costo,
              }
            })
            .then(() => {
              this.currentAlertCounter = 6;
            })
            .catch(rej => {
              // console.log(rej);
              this.error = rej.message;
              this.warningModal = true;
            })

            .finally(() => {
              this.isLoading = false;
            });
        
      }
    },
    addEmpaqueFull() {
      this.isLoading = true;
      this.$store
        .dispatch("customActualizarHTTP", {
          schema: "empaques",
          payload: {
            nombre: this.nombreEmpaque,
          }
        })
        .then(() => {
          this.currentAlertCounter = 6;
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.isLoading = false;
        });
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateEmpaque() {
      this.$v.nombreEmpaque.$touch();
      this.$v.nombreCultivo.$touch();
      this.$v.costo.$touch();
      // this.$v.equivalencia_6oz.$touch();
    },
  },

  created() {
    this.isLoadingPage = true;

    this.$store.dispatch('customHTTP', {
      schema: 'configuracion',
      filter: {
        where: [{field: 'payload->parametro', value: 'cultivos', operator: '='}]
      }
    }).then((configuracion) => {
      this.configuracion = configuracion.data[0].payload.valor
    }).finally(() => (this.isLoadingPage = false));
  },

  mixins: [validationMixin],
  validations: {
    nombreEmpaque: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(100)
    },
    nombreCultivo: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(25)
    },
    costo: {
      required,
      notNegative: (value) => value >= 0
    },

  },

  data() {
    return {
      nombreEmpaque: "",
      nombreCultivo: "",
      costo: "",
      url: "",
      urlName: "",
      warningModal: false,
      isLoading: false,
      isLoadingPage: false,
      currentAlertCounter: 0,
      error: "",
      configuracion: [],
    };
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.custom-width {
  width: 100%;
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
